module.exports = __webpack_public_path__ + "img/banner-13-1@2x.c58a4d7b.jpg";